import React from 'react';
import ErpTablePage from '../components/ErpTablePage';

const ConfigFinancialDimensions = () => {
  return <ErpTablePage moduleKey="config_fin_dims" />;
};

export default ConfigFinancialDimensions;